var getCaptionTextSize = function getCaptionTextSize(size) {
  if (size === 'xs') {
    return 'size6-r';
  }
  if (size === 'm' || size === 's') {
    return 'size5-m';
  }
  return 'size3-m';
};
var getDescriptionTextSize = function getDescriptionTextSize(size) {
  if (size === 'xs' || size === 'm' || size === 's') {
    return 'size6-r';
  }
  return 'size5-r-s';
};
export { getCaptionTextSize, getDescriptionTextSize };